const encoder = new TextEncoder();

function toHex(bytes: Uint8Array): string {
  let out = '';
  for (let i = 0; i < bytes.length; i += 1) {
    out += bytes[i].toString(16).padStart(2, '0');
  }
  return out;
}

export async function computeSaltedPasswordHash(uploadId: string, password: string): Promise<string> {
  if (!uploadId || !password) {
    throw new Error('uploadId and password are required to compute salted hash');
  }

  const payload = `${uploadId}:${password}`;
  const data = encoder.encode(payload);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return toHex(new Uint8Array(digest));
}
